import { RouterProvider } from 'react-router-dom';
import { queryClient, router } from './routes';
import { QueryClientProvider } from '@tanstack/react-query';

const AppRouter = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
};

export default AppRouter;
